import Column from 'src/frontend-common/components/Column';
import { Alert, styled, Typography, Button, Divider, TextField } from '@mui/material';

export const Heading = styled(Column)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(4),
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  lineHeight: 1.2,
  marginBottom: theme.spacing(1),
  textAlign: 'center',
}));

export const Subtitle = styled(Typography)(() => ({
  fontSize: 14,
  lineHeight: 1.1,
  textAlign: 'center',
}));

export const GoogleButton = styled(Button)(({ theme }) => ({
  height: 56,
  width: '100%',
  backgroundColor: 'transparent',
  border: '1px solid rgba(0,0,0,0.23)',
  color: theme.palette.text.primary,
  display: 'inline-flex',
  '&:hover': {
    color: 'black',
    border: `1px solid black`,
    backgroundColor: 'transparent',
  },
}));

export const CustomDivider = styled(Column)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  position: 'relative',
  width: '100%',
}));

export const LabelOr = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary,
  position: 'relative',
  zIndex: 1,
  backgroundColor: 'white',
  padding: '0 10px',
}));

export const Line = styled(Divider)(() => ({
  position: 'absolute',
  zIndex: 0,
  width: '100%',
}));

export const CustomTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(3),
}));

export const LoginButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(1)} 4px`,
  textTransform: 'none',
  textDecoration: 'none',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  '&:hover': { textDecoration: 'none', color: '#391041' },
}));

export const ForgotPasswordButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  textDecoration: 'none',
  fontSize: 14,
  lineHeight: 1.1,
  fontWeight: 600,
  cursor: 'pointer',
  marginBottom: theme.spacing(3),
  '&:hover': { textDecoration: 'none', color: '#391041' },
}));

export const CustomButton = styled(Button)(() => ({
  height: 56,
  width: '100%',
}));

export const CustomAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));
